import "./searchForm.css";
import { useEffect, useState } from "react";
import PlacesAutocomplete, {
    geocodeByAddress,
} from "react-places-autocomplete";
import { GoogleApiWrapper } from "google-maps-react";
import { getCategory, getFilteredProducts, getSubcategory } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import useGeolocation from 'react-hook-geolocation'

const SearchForm = (props) => {

    const [title, setTitle] = useState(props.title);
    const [categoryId, setCategoryId] = useState(props.categoryId);
    const [subCategoryId, setSubCategoryId] = useState(props.subCategoryId);
    const [location, setLocation] = useState(props.location);
    const [distance, setDistance] = useState(props.distance);
    const [marketFilter, setMarketFilter] = useState(props.marketFilter);
    const [address, setAddress] = useState(props.location);
    const history = useHistory();
    const loc = useLocation();
    const [lng, setlng] = useState(props.lng)
    const [lat, setlat] = useState(props.lat)
    const [trigger, settrigger] = useState(0)
    const [subCategoryOptions, setSubCategoryOptions] = useState();
    const geolocation = useGeolocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCategory());
        dispatch(getSubcategory())
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if (loc.state?.viaOther) {

            window.scrollTo(0, 0);
            setTitle(null);
            document.getElementById("searchTitle").value = "";
            setCategoryId(loc.state.categoryId);
            const options = subCategories.filter(subCat => subCat.categoryId === loc.state.categoryId);
            setSubCategoryOptions(options);
            setSubCategoryId(null);
            setLocation(null);
            setDistance(null);
            setMarketFilter(null);
            props.setSort(null);
            setAddress("");
            props.setPageNumber(1);
            const tmp_trg = trigger + 1;
            settrigger(tmp_trg);
        }
    }, [loc])

    useEffect(() => {

        if (!loc.state?.viaOther) {
            const filters = {}
            if (location)
                filters.location = location;
            if (distance && !geolocation.error) {
                filters.distance = distance;
                filters.lng = lng;
                filters.lat = lat;
            }
            if (categoryId)
                filters.categoryId = categoryId;
            if (subCategoryId)
                filters.subCategoryId = subCategoryId;
            if (title)
                filters.title = title;
            if (props.sort)
                filters.sort = props.sort;
            if (marketFilter)
                filters.marketFilter = marketFilter;
            const queryParams = new URLSearchParams(filters);
            history.replace(
                { pathname: loc.pathname, search: queryParams.toString() })
        }
        else if (loc.state?.viaOther || loc.state?.viaHome)
            history.replace(
                { pathname: loc.pathname, search: loc.search })
        props.setOpen(false);
    }, [props.filteredProducts])

    useEffect(() => {
        if (!address)
            setLocation(null)
    }, [address])

    useEffect(() => {
        if (!loc.state?.viaOther) {

            props.setPageNumber(1);
            const new_trg = trigger + 1;
            settrigger(new_trg)
        }
    }, [categoryId, subCategoryId, location, distance, marketFilter, props.sort])

    useEffect(() => {
        let filters = {};
        if (loc.state?.viaOther) {
            filters = {
                title: null, categoryId: loc.state?.categoryId, subCategoryId: null, location: null, distance: null, marketFilter: null, sort: null, lng: null, lat: null
            };
        }
        else {
            console.log("sort filter changed, sort-by: ", props.sort);
            filters = {
                title, categoryId, subCategoryId, location, distance, marketFilter, sort: props.sort, lng, lat
            };
        }

        const skip = (props.pageNumber - 1) * props.docsPerPage;
        props.setOpen(true);
        dispatch(getFilteredProducts(filters, skip, props.pageNumber, props.docsPerPage));
        console.log("onPage change filters are: ", filters)

    }, [props.pageNumber, trigger])

    useEffect(() => {
        if (!geolocation.error) {

            setlng(geolocation.longitude)
            setlat(geolocation.latitude)

        }

    }, [geolocation])

    useEffect(() => {
        if (categoryId && !loc.state?.viaOther) {
            const options = subCategories.filter(subCat => subCat.categoryId === categoryId);
            setSubCategoryOptions(options);
            if (!loc.state?.viaHome)
                setSubCategoryId(null);
            // alert("suspect categoryId useEffect!");
        }
        else if (!loc.state?.viaOther) {
            setSubCategoryId(null);
            setSubCategoryOptions(null);
        }
    }, [categoryId])

    const handleSelect = async (value) => {
        const results = await geocodeByAddress(value);
        const result = results[0];
        const addressComponents = result.address_components;
        for (let i = 0; i < addressComponents.length; i++) {
            let component = addressComponents[i];
            if (component.types.indexOf('locality') !== -1) {
                setLocation(component.long_name);
                break;
            }
        }
        // const latLng = await getLatLng(result);
        setAddress(value);
    }

    const categories = useSelector(state => state.categoryDetail.categories);
    const subCategories = useSelector(state => state.subCategoryDetail.subCategories);

    return (
        <section className="search-form-holder inner-pages-search">
            <div className="container">
                <div className="form-wrapper">
                    <form className="search-form d-flex align-items-center justify-content-between flex-wrap" action="" method="post">
                        <div className="form-group full-w">
                            <div className="input-search-holder">
                                <input id="searchTitle" type="text" className="form-control field-des" placeholder="Update Keyword" onChange={(event) =>
                                    setTitle(event.target.value !== "" ? event.target.value : null)} value={title} />
                                <button className="btn btn-search" onClick={(event) => {
                                    event.preventDefault();
                                    // alert('button click')
                                    props.setPageNumber(1);
                                    const tmp_trg = trigger + 1;
                                    settrigger(tmp_trg);
                                }}><i className="fa fa-search" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className="form-group d-flex align-items-center custom-w">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/category.png").default} className="img-fluid" />
                            </span>
                            <select id="categories" name="categories" className="field-des " form="categoriesform" onChange={(event) => {
                                const value = event.target.value;
                                setCategoryId(value !== "All" ? value : null);
                            }}>
                                <option value="All">All categories</option>
                                {categories && categories.map((category, index) => <option key={index} value={category._id} selected={categoryId === category._id ? true : false}>{category.name}</option>)}
                            </select>
                            

                        </div>
                        <div className="form-group d-flex align-items-center custom-w">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/category.png").default} className="img-fluid" />
                            </span>
                            <select id="subCategories" name="subCategories" className="field-des " form="subCategoriesForm" onChange={(event) => {
                                const value = event.target.value;
                                setSubCategoryId(value !== "All" ? value : null);
                            }}>
                                <option value="All">All sub categories</option>
                                {subCategoryOptions && subCategoryOptions.map((subCategory, index) => <option key={index} value={subCategory._id} selected={subCategoryId === subCategory._id ? true : false}>{subCategory.name}</option>)}
                            </select>
                             
                        </div>
                        <div className="form-group d-flex align-items-center custom-w">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/pin.png").default} className="img-fluid" />
                            </span>
                            <PlacesAutocomplete value={address} onChange={setAddress} onSelect={handleSelect}>
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div className="city-location">
                                        <input {...getInputProps({ placeholder: "Type City" })} type="text" className="form-control field-des" />
                                        <div style={{ position: "relative" }}>
                                            <div style={{
                                                position: "absolute",
                                                zIndex: 1,
                                            }}>
                                                {loading ? <div>...Loading</div> : null}
                                                {suggestions.map((suggestion) => {
                                                    const style = {
                                                        backgroundColor: suggestion.active ? "#ff7e06" : "#fff",
                                                    };
                                                    return <div {...getSuggestionItemProps(suggestion, { style })}>{suggestion.description}</div>;
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </PlacesAutocomplete>
                        </div>
                        <div className="form-group d-flex align-items-center custom-w">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/category.png").default} className="img-fluid" />
                            </span>
                            <select id="marketPlaceFilters" name="marketPlaceFilters" className="field-des" onChange={(event) => {
                                const value = event.target.value;
                                setMarketFilter(value !== "filter" ? value : null);
                            }}>
                                <option value="filter" selected={!marketFilter ? true : false}>MarketPlace Filter</option>
                                <option value="recommended" selected={marketFilter === "recommended" ? true : false}>Recommended</option>
                                <option value="popular" selected={marketFilter === "popular" ? true : false}>Popular</option>
                                <option value="bestSelling" selected={marketFilter === "bestSelling" ? true : false}>Best Selling</option>
                                <option value="trending" selected={marketFilter === "trending" ? true : false}>Trending</option>
                            </select>
                        </div>
                        <div className="form-group d-flex align-items-center custom-w">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/arrows.png").default} className="img-fluid" />
                            </span>
                            <select id="distance" name="distance" className="field-des" form="distanceform" onChange={(event) => {
                                const value = event.target.value;
                                setDistance(value !== "null" ? value : null);
                            }}>
                                {!geolocation.longitude && <option value="null" >Allow the location.</option>}
                                {!geolocation.error && lng && lat && <option value="null" >Select a distance</option>}
                                {!geolocation.error && lng && lat && <option selected={distance === "10" ? true : false} value="10" >10kms</option>}
                                {!geolocation.error && lng && lat && <option selected={distance === "100" ? true : false} value="100">100kms </option>}
                                {!geolocation.error && lng && lat && <option selected={distance === "500" ? true : false} value="500">500kms</option>}
                                {!geolocation.error && lng && lat && <option selected={distance === "1000" ? true : false} value="1000">1000kms</option>}
                                {!geolocation.error && lng && lat && <option selected={distance === "5000" ? true : false} value="5000">5000kms</option>}
                                {!geolocation.error && lng && lat && <option selected={distance === "1500" ? true : false} value="1500">1500kms</option>}
                                {!geolocation.error && lng && lat && <option selected={distance === "2000" ? true : false} value="2000">2000kms</option>}
                            </select>
                        </div>

                    </form>
                </div>
            </div>
        </section>
    );
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyBApvvMp-DolYwwyo3C2jpq6lGDpZzLeiU",
    libraries: ["places"],
})(SearchForm);